
export const RoutesData = {
    Home: "/"
}
